import { Button } from "@capacit-com/lara-law-shared-ui";
import { ChevronRight, Home } from "lucide-react";
import { useFileOperations } from "@/pages/workspace/hooks/useFileOperations";
import { cn } from "@/lib/utils";

interface FilesBreadCrumbsProps {
  currentPath: { id: string; name: string }[];
  navigateToPath: (index: number) => void;
}

const FilesBreadCrumbs = ({
  currentPath,
  navigateToPath,
}: FilesBreadCrumbsProps) => {
  const {
    draggedItem,
    pathSegmentDropTarget,
    handlePathSegmentDragOver,
    handlePathSegmentDragLeave,
    handleDropOnPathSegment,
  } = useFileOperations();

  const isDropTarget = draggedItem !== null;

  return (
    <div className="flex items-center gap-1 text-sm">
      <Button
        variant="ghost"
        size="sm"
        className={cn(
          "h-8 px-2 transition-colors",
          isDropTarget && "rounded-md",
          pathSegmentDropTarget === "root" && "bg-muted ring-1 ring-primary/50"
        )}
        onClick={() => navigateToPath(-1)}
        onDragOver={(e) => {
          if (isDropTarget) {
            e.preventDefault();
            e.dataTransfer.dropEffect = "move";
            handlePathSegmentDragOver("root");
          }
        }}
        onDragLeave={() => handlePathSegmentDragLeave()}
        onDrop={(e) => {
          if (isDropTarget) {
            void handleDropOnPathSegment(e, null);
          }
        }}
      >
        <Home className="mr-1 size-4" />
        Hjem
      </Button>
      {currentPath.length > 0 && (
        <ChevronRight className="size-4 shrink-0 text-muted-foreground" />
      )}
      {currentPath.map((path, index) => (
        <div key={path.id + index} className="flex items-center">
          <Button
            variant="ghost"
            size="sm"
            className={cn(
              "h-8 px-2 transition-colors",
              isDropTarget && "rounded-md",
              pathSegmentDropTarget === path.id && "bg-muted ring-1 ring-primary/50"
            )}
            onClick={() => navigateToPath(index)}
            onDragOver={(e) => {
              if (isDropTarget) {
                e.preventDefault();
                e.dataTransfer.dropEffect = "move";
                handlePathSegmentDragOver(path.id);
              }
            }}
            onDragLeave={() => handlePathSegmentDragLeave()}
            onDrop={(e) => {
              if (isDropTarget) {
                void handleDropOnPathSegment(e, path.id);
              }
            }}
          >
            {path.name}
          </Button>
          {index < currentPath.length - 1 && (
            <ChevronRight className="size-4 shrink-0 text-muted-foreground" />
          )}
        </div>
      ))}
    </div>
  );
};

export default FilesBreadCrumbs;
